import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs'; 
const ChatbotWidget: React.FC<{}> = () => {

  const [isChatOpen, setIsChatOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Dynamically add the stylesheet to the page
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/images/bot/chat.css';
    document.head.appendChild(link);

    // Cleanup function to remove the stylesheet when component unmounts
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.action === 'handelCloseBotModal') {
        setIsChatOpen(false);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  // Show tooltip on component mount and auto-hide after 5 seconds
  useEffect(() => {
    setShowTooltip(true);
    const timer = setTimeout(() => {
      setShowTooltip(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  const toggleChat = () => {
    const newState = !isChatOpen;
    setIsChatOpen(newState);
    
    if (newState && iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        { action: 'handelOpeningBot' },
        '*'
      );
    } else if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        { action: 'handelCloseBotIcon' },
        '*'
      );
    }
  };

  const closeChat = () => {
    setIsChatOpen(false);
    if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        { action: 'handelCloseBotIcon' },
        '*'
      );
    }
  };

  const getChatWindowStyles = () => {
    if (windowSize.width > 768) {
      return {
        width: '40vw',
        height: '85vh',
        borderRadius: '16px 16px 0px 0px',
        right: '0px',
      };
    } else {
      return {
        width: '96vw',
        height: '96vh',
        borderRadius: '16px 16px 0px 0px',
        right: '2vw',
      };
    }
  };

  const getCloseButtonStyles = () => {
    if (windowSize.width > 768) {
      return {
        bottom: '80vh',
        right: '1vw',
      };
    } else {
      return {
        bottom: '90vh',
        right: '3vw',
      };
    }
  };

  return (
    <>
      {/* Custom Animated Tooltip/Popover */}
      {showTooltip && (
        <div className="chatbot-tooltip-container">
          <div className="chatbot-tooltip-box">
            <button 
              className="chatbot-tooltip-close"
              onClick={() => setShowTooltip(false)}
              aria-label="Close tooltip">×</button>
            <p className="chatbot-tooltip-text">Namaste! I'm Radha, your personal assistant. How can I help you?</p>
          </div>
          <div className="chatbot-tooltip-pointer"></div>
        </div>
      )}

      <button 
        onClick={toggleChat} 
        style={{ position: 'fixed', bottom: '2%', right: '1%', zIndex: 50 }}
        className="chatbot-robot-button">
        <img src={require("@assets/images/chat-bot-radha.gif")} alt="Chat Bot" className="chatbot-gif" />
      </button> 
      <div
        id="chatbot-window"
        style={{
          position: 'fixed',
          bottom: '0px',
          right: getChatWindowStyles().right,
          width: getChatWindowStyles().width,
          height: getChatWindowStyles().height,
          backgroundColor: 'white',
          overflow: 'hidden',
          zIndex: 1000,
          display: isChatOpen ? 'block' : 'none',
          borderWidth: '2px',
          borderRadius: getChatWindowStyles().borderRadius,
          border: '1px solid var(--brand-100)'
        }}
      >
        <iframe
          id="chatbot-iframe"
          ref={iframeRef}
          allow="clipboard-write"
          src={process.env.REACT_APP_CHATBOT_URL}
          style={{ width: '100%', height: '100%', border: 'none' }}
          title="Chatbot"
        />
      </div>
      <div
        id="close-chatbot-button"
        onClick={closeChat}
        style={{
          position: 'fixed',
          right: getCloseButtonStyles().right,
          bottom: getCloseButtonStyles().bottom,
          width: '30px',
          height: '30px',
          padding: '4px',
          color: '#111',
          cursor: 'pointer',
          zIndex: 1001,
          display: isChatOpen ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          borderRadius: '50%',
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          style={{ width: '100%', height: '100%' }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </div>
    </>
  );
};

export default ChatbotWidget;